import { MethodCommandList } from '~/features/command-lists'

import { useFilterMutator } from '../hooks'

export function MethodFilterControl() {
  const { onSelect, selection } = useFilterMutator()
  return <MethodCommandList selected={selection} onSelect={onSelect} multiselect />
}
